import React, { useContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import {Modal, Button, Form, Row, Col, Dropdown } from "react-bootstrap";
import { AnchorComponent } from "../../components/elements";
import { FloatCardComponent, ListadoUsuariosGiraComponent, ResumenPasajerosComponent } from "../../components/cards";
import PageLayout from "../../layouts/PageLayout";
import {getEstablecimientos, getRegiones, getComunas, getProgramas, getTramos, getReporteGiras, descargarArchivo} from "../../api/mantenedores.ts";
import {editarGira, getGira, generarCodigoQRPasajeros, obtenerCoordinadoresGira, asignarCoordinadoresGira} from "../../api/giras.ts";
import {obtenerCoordinadores} from "../../api/usuarios.api.ts";
import Swal from 'sweetalert2';

export default function GiraViewPage() {

    const { t } = useContext(TranslatorContext)
    const location = useLocation();
    const navigate = useNavigate();

    const [giraData, setGiraData] = useState({});
    const [giraDataView, setGiraDataView] = useState({});
    const [reporteData, setReporteData] = useState({});

     const [selectEstablecimiento, setSelectEstablecimiento] = useState([]);
        const [selectRegion, setSelectRegion] = useState([]);
        const [selectComuna, setSelectComuna] = useState([]);
        const [selectPrograma, setSelectPrograma] = useState([]);
        const [selectTramo, setSelectTramo] = useState([]);
        const [comunas, setComunas] = useState([]);
        const [showCreateGiraModal, setShowCreateGiraModal] = useState(false);
        const [showQRModal, setShowQRModal] = useState(false);
        const [qrData, setQrData] = useState(null);
        const [loadingQR, setLoadingQR] = useState(false);
        const [showCoordinadoresModal, setShowCoordinadoresModal] = useState(false);
        const [coordinadoresDisponibles, setCoordinadoresDisponibles] = useState([]);
        const [coordinadoresSeleccionados, setCoordinadoresSeleccionados] = useState([]);
        const [loadingCoordinadores, setLoadingCoordinadores] = useState(false);

        const handleShowCreateGiraModal = () => setShowCreateGiraModal(true);
        const handleCloseCreateGiraModal = () => setShowCreateGiraModal(false);
        const handleShowQRModal = () => setShowQRModal(true);
        const handleCloseQRModal = () => setShowQRModal(false);
        const handleShowCoordinadoresModal = async () => {
          await loadCoordinadores();
          setShowCoordinadoresModal(true);
        };
        const handleCloseCoordinadoresModal = () => {
          setShowCoordinadoresModal(false);
          setCoordinadoresSeleccionados([]);
        };

        // Función helper para convertir formato ISO (2026-09-03T13:47:00.000Z) a datetime-local (2026-09-03T13:47)
        const formatDateTimeForInput = (dateString) => {
          if (!dateString) return '';
          try {
            // Crear objeto Date desde el string ISO
            const date = new Date(dateString);
            // Formatear a YYYY-MM-DDTHH:mm
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day}T${hours}:${minutes}`;
          } catch (error) {
            return dateString;
          }
        };

        // Función para convertir de formato datetime-local a formato MySQL (YYYY-MM-DD HH:mm:ss)
        const formatDateTimeForBackend = (dateString) => {
          if (!dateString) return null;
          try {
            // El input datetime-local tiene formato YYYY-MM-DDTHH:mm
            // Parsearlo manualmente para evitar problemas de zona horaria
            const [date, time] = dateString.split('T');
            const [year, month, day] = date.split('-');
            const [hours, minutes] = time.split(':');
            
            // Devolver en formato MySQL: YYYY-MM-DD HH:mm:ss
            return `${year}-${month}-${day} ${hours}:${minutes}:00`;
          } catch (error) {
            console.error('Error al formatear fecha:', error);
            return null;
          }
        };

     useEffect(() => {
                const params = new URLSearchParams(location.search); // Analiza los parámetros de la consulta
                const giraId = params.get('gira'); // Obtén el valor del parámetro 'gira'
               
                
                const fetchTabla = async () => {
                  
                    const res = await getGira(giraId);
                    console.log(res.gira);
                    // Convertir fecha de reunión pre-salida al formato datetime-local
                    const giraWithFormattedDate = {
                      ...res.gira,
                      gir_fecha_reunion_presalida: formatDateTimeForInput(res.gira.gir_fecha_reunion_presalida)
                    };
                    setGiraData(giraWithFormattedDate);
                    setGiraDataView(res.gira);
                    setReporteData(res.reporte);
                    
                    

                }
                
                 const fectchProgramas = async () => {
                                const res = await getProgramas();
                                console.log(res);
                                setSelectPrograma(res.data);
                            }
                
                            const fectchTramos = async () => {
                                const res = await getTramos();
                                console.log(res);
                                setSelectTramo(res.data);
                            }
                
                            const fectchEstablecimientos = async () => {
                                const res = await getEstablecimientos();
                                console.log(res);
                                setSelectEstablecimiento(res.data);
                            }
                
                            const fecthregiones = async () => {
                                const res = await getRegiones();
                                console.log(res);
                                setSelectRegion(res.data);
                            }   
                    
                            const fecthComunas = async () => {
                                const res = await getComunas();
                                console.log(res);
                                setSelectComuna(res.data);
                            }
                 fectchProgramas();
                fectchTramos();
                fectchEstablecimientos();
                fecthregiones();
                fecthComunas();
                
                fetchTabla();   
               
            }, []);

            useEffect(() => {
                
                if (showCreateGiraModal && giraData.idregion) {
                   
                     const fetchedComunas = selectComuna.filter(comuna => comuna.reg_id === parseInt(giraData.idregion));
                   
                    setComunas(fetchedComunas);
                }
            }, [showCreateGiraModal, giraData.idregion]);

            useEffect(() => {
                if (showCreateGiraModal && giraData.idcomuna) {
                    fetchEstablecimientos(giraData.idcomuna);
                }
            }, [showCreateGiraModal, giraData.idcomuna]);

            useEffect(() => {
                // Calcular el valor total gira (Precio Unitario + Servicio Adicional)
                if (giraData.gir_valorgira) {
                    const valorUnitario = typeof giraData.gir_valorgira === 'string' 
                        ? parseFloat(giraData.gir_valorgira.replace(',', '.'))
                        : parseFloat(giraData.gir_valorgira);
                    
                    const servicioAdicional = typeof giraData.gir_valor_servicio_adicional === 'string' 
                        ? parseFloat(giraData.gir_valor_servicio_adicional.replace(',', '.')) || 0
                        : (parseFloat(giraData.gir_valor_servicio_adicional) || 0);
                    
                    const total = valorUnitario + servicioAdicional;
                    
                    setGiraData(prev => ({
                        ...prev,
                        gir_valor_total_gira: isNaN(total) ? '' : total
                    }));
                }
            }, [giraData.gir_valorgira, giraData.gir_valor_servicio_adicional]);

            const handleInputChange = (event) => {
                const { name, value, type, checked } = event.target;
                setGiraData({
                    ...giraData,
                    [name]: type === 'checkbox' ? checked : value
                });
                console.log(giraData);
            };

            const handleInputChangeDolar = (event) => {
                const { name, checked } = event.target;
                setGiraData({
                    ...giraData,
                    [name]: {
                        data: [checked ? 1 : 0],
                        type: "Buffer"
                    }
                });
                console.log(giraData);
            };

            const handleRegionChange = (event) => {
            const { value } = event.target;
            setGiraData({
                ...giraData,
                idregion: value,
                idcomuna: '' // Reset comuna when region changes
            });
            // Fetch comunas based on selected region
            fetchComunas(value);
        };

        
    const fetchComunas = (regionId) => {
        // Replace with your actual API call
        const fetchedComunas = selectComuna.filter(comuna => comuna.reg_id === parseInt(regionId));
        console.log(fetchedComunas);
        setComunas(fetchedComunas);
    };

    const handleComunaChange = (event) => {
        const { value } = event.target;
        setGiraData({
            ...giraData,
            idcomuna: value
        });
        // Fetch establecimientos based on selected comuna
        fetchEstablecimientos(value);
    };

    const fetchEstablecimientos = async (comunaId) => {
        const res = await getEstablecimientos(comunaId);
        console.log(res);
        setSelectEstablecimiento(res.data);
    };

    const toInputDate = (fecha) => {
          if (!fecha) return "";
            // Si ya está en formato yyyy-mm-dd, retorna igual
            if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) return fecha;
            // Si está en formato dd/mm/yyyy, lo transforma
            const [d, m, y] = fecha.split("/");
            return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
    }    

    const handleEditarGira = () => {
            // Aquí puedes manejar la lógica para editar la gira de estudios
            
            // Convertir fecha de vuelta al formato ISO para el backend
            const dataToSend = {
              ...giraData,
              gir_fecha_reunion_presalida: formatDateTimeForBackend(giraData.gir_fecha_reunion_presalida)
            };
        
            editarGira(dataToSend)
            .then(async res => {
              Swal.close();
              
              if (res && res.error === false) {
                 const giraRes = await getGira(giraData.gir_id);
                 // Convertir fecha al cargar nuevamente
                 const giraWithFormattedDate = {
                   ...giraRes.gira,
                   gir_fecha_reunion_presalida: formatDateTimeForInput(giraRes.gira.gir_fecha_reunion_presalida)
                 };
                    
                    setGiraData(giraWithFormattedDate);
                    setGiraDataView(giraRes.gira);
                    setReporteData(giraRes.reporte);
                    
                handleCloseCreateGiraModal();
                
                Swal.fire({
                  icon: 'success',
                  text: res.message || 'Gira editada correctamente.'
                })
                
              }
              else if (res && res.error === true) {
                let errorMsg = res?.message || res?.msg || 'Error al editar la gira';
                if (res?.errores && Array.isArray(res.errores)) {
                  errorMsg += '<table class="w-full leading-normal text-md bg-white"><thead><tr class="border-b-2 table-main font-semibold text-xs text-gray-600 uppercase tracking-wider"><th class="px-5 py-3 text-center">ID Manzanas</th><tbody>';
                  res.errores.forEach(error => {
                    errorMsg += `<tr class="border-b cursor-pointer text-gray-800"><td>${error}</td></tr>`;
                  });
                  errorMsg += '</tbody></table>';
                }
    
                Swal.fire({
                  icon: 'error',
                  html: errorMsg
                })
              }
    
            })
            .catch(err => {
              Swal.close();
              console.error('Error al editar gira:', err);
              Swal.fire({
                icon: 'error',
                text: 'Error de conexión al editar la gira'
              })
            });
        };

    const handleGenerarCodigoQR = async () => {
      setLoadingQR(true);
      try {
        const resultado = await generarCodigoQRPasajeros(giraData.gir_id);
        
        if (resultado && !resultado.error) {
          setQrData({
            codigoQR: resultado.codigoQR,
            enlace: resultado.enlace,
            hash: resultado.hash
          });
          handleShowQRModal();
          Swal.fire({
            icon: 'success',
            title: 'QR Generado',
            text: 'El código QR ha sido generado exitosamente'
          });
        } else {
          const errorMsg = resultado?.message || 'Error al generar el código QR';
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMsg
          });
        }
      } catch (error) {
        console.error('Error:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error de conexión al generar el código QR'
        });
      } finally {
        setLoadingQR(false);
      }
    };

    const handleDescargarQR = async () => {
      if (!qrData?.codigoQR) return;
      
      try {
        // Si codigoQR es base64, crear elemento para descargar
        const link = document.createElement('a');
        link.href = qrData.codigoQR;
        link.download = `QR-Pasajeros-Gira-${giraData.gir_id}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Error al descargar:', error);
        Swal.fire({
          icon: 'error',
          text: 'Error al descargar el código QR'
        });
      }
    };

    const handleCopiarEnlace = async () => {
      if (!qrData?.enlace) return;
      
      try {
        await navigator.clipboard.writeText(qrData.enlace);
        Swal.fire({
          icon: 'success',
          title: 'Enlace copiado',
          text: 'El enlace ha sido copiado al portapapeles',
          timer: 2000
        });
      } catch (error) {
        console.error('Error al copiar:', error);
        Swal.fire({
          icon: 'error',
          text: 'Error al copiar el enlace'
        });
      }
    };

    const loadCoordinadores = async () => {
      try {
        setLoadingCoordinadores(true);
        
        // Obtener coordinadores disponibles
        const coordResponse = await obtenerCoordinadores();
        if (!coordResponse.error && coordResponse.coordinadores) {
          setCoordinadoresDisponibles(coordResponse.coordinadores);
        }

        // Obtener coordinadores ya asignados a esta gira
        const asignadosResponse = await obtenerCoordinadoresGira(giraData.gir_id);
        if (!asignadosResponse.error && asignadosResponse.coordinadores) {
          const ids = asignadosResponse.coordinadores.map(c => c.usuario_id);
          setCoordinadoresSeleccionados(ids);
        }
      } catch (error) {
        console.error('Error loading coordinadores:', error);
        Swal.fire('Error', 'Error al cargar coordinadores', 'error');
      } finally {
        setLoadingCoordinadores(false);
      }
    };

    const handleToggleCoordinador = (coordinadorId) => {
      setCoordinadoresSeleccionados(prev => 
        prev.includes(coordinadorId)
          ? prev.filter(id => id !== coordinadorId)
          : [...prev, coordinadorId]
      );
    };

    const handleGuardarCoordinadores = async () => {
      try {
        setLoadingCoordinadores(true);
        const response = await asignarCoordinadoresGira(giraData.gir_id, coordinadoresSeleccionados);
        
        if (!response.error) {
          Swal.fire('Éxito', 'Coordinadores asignados correctamente', 'success');
          handleCloseCoordinadoresModal();
        } else {
          Swal.fire('Error', response.msg || 'Error al asignar coordinadores', 'error');
        }
      } catch (error) {
        console.error('Error saving coordinadores:', error);
        Swal.fire('Error', 'Error al guardar coordinadores', 'error');
      } finally {
        setLoadingCoordinadores(false);
      }
    };

    const floats = [
        { "title": "Total Gira", "digit": (giraDataView.gir_pagodolares?.data[0] ? "US$" : "$") + reporteData.total_gira?.toLocaleString('es-CL'), "icon": "shopping_cart", "variant": "sm pink" }, 
        { "title": "Pagado", "digit": (giraDataView.gir_pagodolares?.data[0] ? "US$" : "$") + parseInt(reporteData.total_pagado || 0)?.toLocaleString('es-CL'), "icon": "hotel_class", "variant": "sm  blue" },
        { "title": "Deuda", "digit": (giraDataView.gir_pagodolares?.data[0] ? "US$" : "$") + reporteData.deuda?.toLocaleString('es-CL'), "icon": "shopping_bag", "variant": "sm orange" }
    ]
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">Gira de Estudio</h3>
                            <ul className="mc-breadcrumb-list">
                            <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">Administración</Link></li>
                                <li className="mc-breadcrumb-item">Giras</li>
                            </ul>
                        </div>
                    </div>
                </Col>
            </Row>

            {/* INFORMACIÓN PRINCIPAL DE GIRA */}
            <Row className="mb-4">
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-card-header">
                            <h4 className="mc-card-title">{giraDataView.est_nombre} - CURSO: {giraDataView.gir_curso}</h4>
                            <Dropdown bsPrefix="mc-dropdown">
                                <Dropdown.Toggle bsPrefix="mc-dropdown-toggle">
                                    <i className='material-icons'>more_horiz</i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu align="end" className="mc-dropdown-paper">
                                    <button type='button' className='mc-dropdown-menu'  onClick={handleShowCreateGiraModal}><i className='material-icons'>edit</i><span>Editar Gira</span></button>
                                    <Link to={`/admin-reembolsos?gira=${new URLSearchParams(location.search).get('gira')}`} className='mc-dropdown-menu'><i className='material-icons'>request_quote</i><span>Administrar Reembolsos</span></Link>
                                    <button type='button' className='mc-dropdown-menu' onClick={handleGenerarCodigoQR} disabled={loadingQR}><i className='material-icons'>qr_code</i><span>{loadingQR ? 'Generando...' : 'Generar Código QR'}</span></button>
                                    <button type='button' className='mc-dropdown-menu' onClick={handleShowCoordinadoresModal}><i className='material-icons'>people</i><span>Asignar Coordinadores</span></button>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div style={{ padding: '20px' }}>
                            <Row className="mb-3">
                                <Col md={3}>
                                    <div>
                                        <strong>Programa</strong>
                                        <p>{giraDataView.programa}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Tramo</strong>
                                        <p>{giraDataView.tramo}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Región</strong>
                                        <p>{giraDataView.reg_nombre}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Comuna</strong>
                                        <p>{giraDataView.com_nombre}</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={3}>
                                    <div>
                                        <strong>Fecha Inicio Viaje</strong>
                                        <p>{giraDataView.gir_fviaje || 'No definida'}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Fecha Término Viaje</strong>
                                        <p>{giraDataView.gir_fterminoviaje || 'No definida'}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Liberados</strong>
                                        <p>{giraDataView.gir_liberados}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Moneda</strong>
                                        <p>{giraDataView.gir_pagodolares?.data[0] ? "Dólares (USD)" : "Pesos Chilenos (CLP)"}</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>

            {/* INFORMACIÓN DE PAGOS Y CUOTAS */}
            <Row className="mb-4">
                <Col xl={12}>
                    <Row>
                        {floats.map((float, index) => (
                            <Col md={4} lg={4} key={ index }>
                                <FloatCardComponent 
                                    variant={ float.variant }
                                    digit={ float.digit }
                                    title={ float.title }
                                    icon={ float.icon }
                                />
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>

            {/* DETALLES DE CUOTAS Y CONFIGURACIÓN */}
            <Row className="mb-4">
                <Col xl={12}>
                    <div className="mc-card" style={{ backgroundColor: '#fffde7' }}>
                        <div style={{ padding: '20px', borderBottom: '1px solid #fff9c4' }}>
                            <h6 style={{ margin: 0, color: '#f57f17', fontWeight: 'bold' }}>Configuración de Cuotas</h6>
                        </div>
                        <div style={{ padding: '20px' }}>
                            <Row className="mb-3">
                                <Col md={3}>
                                    <div>
                                        <strong>Número de Cuotas</strong>
                                        <p>{giraDataView.gir_numcuotas}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Valor Gira</strong>
                                        <p>{giraDataView.gir_valorgira}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Valor Servicio Adicional</strong>
                                        <p>{giraDataView.gir_valor_servicio_adicional}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Valor Total Gira</strong>
                                        <p>{giraDataView.gir_valor_total_gira}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Valor Cuota</strong>
                                        <p>{giraDataView.gir_valorcuota}</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={3}>
                                    <div>
                                        <strong>Abono Pagado</strong>
                                        <p>{giraDataView.gir_abonopagado}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Fecha Inicio Cuotas</strong>
                                        <p>{giraDataView.gir_fechainiciocuotasver}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Fecha Última Cuota</strong>
                                        <p>{giraDataView.gir_fechaultimaacuotaver}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Fecha Límite Edición</strong>
                                        <p>{giraDataView.gir_fechalimiteedicionver}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Aplica Multa</strong>
                                        <p>{giraDataView.gir_multa?.data[0] ? "Sí" : "No"}</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3}>
                                    <div>
                                        <strong>Tipo Multa</strong>
                                        <p>{giraDataView.gir_mulmensual?.data[0] ? "Mensual" : "Diaria"}</p>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div>
                                        <strong>Porcentaje Multa</strong>
                                        <p>{giraDataView.gir_porcmulta}%</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>

            {/* INFORMACIÓN DE CONTACTO */}
            <Row className="mb-4">
                <Col xl={12}>
                    <div className="mc-card" style={{ backgroundColor: '#e3f2fd' }}>
                        <div style={{ padding: '20px', borderBottom: '1px solid #bbdefb' }}>
                            <h6 style={{ margin: 0, color: '#1565c0', fontWeight: 'bold' }}>Información de Contacto</h6>
                        </div>
                        <div style={{ padding: '20px' }}>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <strong>Nombre Contacto</strong>
                                        <p>{giraDataView.gir_contacto}</p>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <strong>Celular Contacto</strong>
                                        <p>{giraDataView.gir_celcontacto}</p>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <strong>Email Contacto</strong>
                                        <p>{giraDataView.gir_emailcontacto}</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>

            {/* INFORMACIÓN ADICIONAL (OPCIONAL) */}
            {(giraDataView.gir_coordinador || giraDataView.gir_gestor || giraDataView.gir_tipo_transporte || giraDataView.gir_hotel || giraDataView.gir_voucher_seguro || giraDataView.gir_tipo_bus || giraDataView.gir_aerolinea || giraDataView.gir_codigo_reserva_vuelo || giraDataView.gir_traslado === true || giraDataView.gir_traslado === 1 || giraDataView.gir_fecha_reunion_presalida || giraDataView.gir_modalidad_reunion) && (
                <Row className="mb-4">
                    <Col xl={12}>
                        <div className="mc-card" style={{ backgroundColor: '#f3e5f5' }}>
                            <div style={{ padding: '20px', borderBottom: '1px solid #e1bee7' }}>
                                <h6 style={{ margin: 0, color: '#6a1b9a', fontWeight: 'bold' }}>Información Adicional (Opcional)</h6>
                            </div>
                            <div style={{ padding: '20px' }}>
                                <Row className="mb-3">
                                    {giraDataView.gir_coordinador && (
                                        <Col md={3}>
                                            <div>
                                                <strong>Coordinador</strong>
                                                <p>{giraDataView.gir_coordinador}</p>
                                            </div>
                                        </Col>
                                    )}
                                    {giraDataView.gir_gestor && (
                                        <Col md={3}>
                                            <div>
                                                <strong>Gestor</strong>
                                                <p>{giraDataView.gir_gestor}</p>
                                            </div>
                                        </Col>
                                    )}
                                    {giraDataView.gir_tipo_transporte && (
                                        <Col md={3}>
                                            <div>
                                                <strong>Tipo de Transporte</strong>
                                                <p>{giraDataView.gir_tipo_transporte}</p>
                                            </div>
                                        </Col>
                                    )}
                                    {giraDataView.gir_hotel && (
                                        <Col md={3}>
                                            <div>
                                                <strong>Hotel</strong>
                                                <p>{giraDataView.gir_hotel}</p>
                                            </div>
                                        </Col>
                                    )}
                                </Row>
                                
                                {giraDataView.gir_tipo_transporte === 'Terrestre' && (
                                    <Row className="mb-3">
                                        {giraDataView.gir_tipo_bus && (
                                            <Col md={3}>
                                                <div>
                                                    <strong>Tipo de Bus</strong>
                                                    <p>{giraDataView.gir_tipo_bus}</p>
                                                </div>
                                            </Col>
                                        )}
                                        {giraDataView.gir_patente_bus && (
                                            <Col md={3}>
                                                <div>
                                                    <strong>Patente Bus</strong>
                                                    <p>{giraDataView.gir_patente_bus}</p>
                                                </div>
                                            </Col>
                                        )}
                                        {giraDataView.gir_nombre_chofer1 && (
                                            <Col md={3}>
                                                <div>
                                                    <strong>Nombre Chofer 1</strong>
                                                    <p>{giraDataView.gir_nombre_chofer1}</p>
                                                </div>
                                            </Col>
                                        )}
                                        {giraDataView.gir_tel_chofer1 && (
                                            <Col md={3}>
                                                <div>
                                                    <strong>Teléfono Chofer 1</strong>
                                                    <p>{giraDataView.gir_tel_chofer1}</p>
                                                </div>
                                            </Col>
                                        )}
                                        {giraDataView.gir_nombre_chofer2 && (
                                            <Col md={3}>
                                                <div>
                                                    <strong>Nombre Chofer 2</strong>
                                                    <p>{giraDataView.gir_nombre_chofer2}</p>
                                                </div>
                                            </Col>
                                        )}
                                        {giraDataView.gir_tel_chofer2 && (
                                            <Col md={3}>
                                                <div>
                                                    <strong>Teléfono Chofer 2</strong>
                                                    <p>{giraDataView.gir_tel_chofer2}</p>
                                                </div>
                                            </Col>
                                        )}
                                    </Row>
                                )}

                                {giraDataView.gir_tipo_transporte === 'Terrestre' && (
                                    <Row className="mb-3">
                                        {giraDataView.gir_horario_salida && (
                                            <Col md={3}>
                                                <div>
                                                    <strong>Horario de Salida</strong>
                                                    <p>{giraDataView.gir_horario_salida}</p>
                                                </div>
                                            </Col>
                                        )}
                                        {giraDataView.gir_horario_regreso && (
                                            <Col md={3}>
                                                <div>
                                                    <strong>Horario de Regreso</strong>
                                                    <p>{giraDataView.gir_horario_regreso}</p>
                                                </div>
                                            </Col>
                                        )}
                                    </Row>
                                )}

                                {giraDataView.gir_tipo_transporte === 'Aéreo' && (
                                    <Row className="mb-3">
                                        {giraDataView.gir_aerolinea && (
                                            <Col md={3}>
                                                <div>
                                                    <strong>Aerolínea</strong>
                                                    <p>{giraDataView.gir_aerolinea}</p>
                                                </div>
                                            </Col>
                                        )}
                                        {giraDataView.gir_num_vuelo && (
                                            <Col md={3}>
                                                <div>
                                                    <strong>Número de Vuelo</strong>
                                                    <p>{giraDataView.gir_num_vuelo}</p>
                                                </div>
                                            </Col>
                                        )}
                                        {giraDataView.gir_codigo_reserva_vuelo && (
                                            <Col md={3}>
                                                <div>
                                                    <strong>Código Reserva Vuelo</strong>
                                                    <p>{giraDataView.gir_codigo_reserva_vuelo}</p>
                                                </div>
                                            </Col>
                                        )}
                                        {giraDataView.gir_horario_vuelo_ida && (
                                            <Col md={3}>
                                                <div>
                                                    <strong>Horario Vuelo Ida</strong>
                                                    <p>{giraDataView.gir_horario_vuelo_ida}</p>
                                                </div>
                                            </Col>
                                        )}
                                        {giraDataView.gir_horario_vuelo_regreso && (
                                            <Col md={3}>
                                                <div>
                                                    <strong>Horario Vuelo Regreso</strong>
                                                    <p>{giraDataView.gir_horario_vuelo_regreso}</p>
                                                </div>
                                            </Col>
                                        )}
                                    </Row>
                                )}

                                {(giraDataView.gir_traslado === true || giraDataView.gir_traslado === 1) && (
                                    <Row className="mb-3">
                                        {giraDataView.gir_punto_encuentro && (
                                            <Col md={3}>
                                                <div>
                                                    <strong>Punto de Encuentro</strong>
                                                    <p>{giraDataView.gir_punto_encuentro}</p>
                                                </div>
                                            </Col>
                                        )}
                                        {giraDataView.gir_horario_encuentro && (
                                            <Col md={3}>
                                                <div>
                                                    <strong>Horario de Encuentro</strong>
                                                    <p>{giraDataView.gir_horario_encuentro}</p>
                                                </div>
                                            </Col>
                                        )}
                                    </Row>
                                )}

                                {giraDataView.gir_voucher_seguro && (
                                    <Row>
                                        <Col md={3}>
                                            <div>
                                                <strong>Nº Voucher Seguro Médico</strong>
                                                <p>{giraDataView.gir_voucher_seguro}</p>
                                            </div>
                                        </Col>
                                    </Row>
                                )}

                                {(giraDataView.gir_fecha_reunion_presalida || giraDataView.gir_modalidad_reunion) && (
                                    <Row className="mb-3" style={{ borderTop: '1px solid #e1bee7', paddingTop: '15px' }}>
                                        {giraDataView.gir_fecha_reunion_presalida && (
                                            <Col md={3}>
                                                <div>
                                                    <strong>Reunión Pre-Salida</strong>
                                                    <p>{new Date(giraDataView.gir_fecha_reunion_presalida).toLocaleString('es-CL')}</p>
                                                </div>
                                            </Col>
                                        )}
                                        {giraDataView.gir_modalidad_reunion && (
                                            <Col md={3}>
                                                <div>
                                                    <strong>Modalidad Reunión</strong>
                                                    <p style={{ textTransform: 'capitalize', fontWeight: '500', color: giraDataView.gir_modalidad_reunion === 'virtual' ? '#1976d2' : '#43a047' }}>
                                                        {giraDataView.gir_modalidad_reunion === 'virtual' ? '🌐 Virtual' : '📍 Presencial'}
                                                    </p>
                                                </div>
                                            </Col>
                                        )}
                                    </Row>
                                )}
                            </div>
                        </div>
                    </Col>
                </Row>
            )}

            {/* BOTÓN VOLVER */}
            <Row className="mb-4">
                <Col xl={12}>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        <button type='button' className='btn btn-secondary' onClick={() => navigate('/listado-giras')} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className='material-icons'>arrow_back</i>
                            <span>Volver</span>
                        </button>
                    </div>
                </Col>
            </Row>

            {/* LISTADO DE PASAJEROS */}
            <Row className="mb-4">
                <Col xl={12}>
                    <ResumenPasajerosComponent gira={giraDataView} />
                </Col>
            </Row>

            {/* TABLA DETALLADA DE PASAJEROS */}
            <Row className="mb-4" >
                <Col xl={12} >
                   
                        <ListadoUsuariosGiraComponent gira={giraDataView} /> 
                   
                </Col>
            </Row>

            <Modal centered backdrop="static" show={showCreateGiraModal} onHide={handleCloseCreateGiraModal}>
                        <div className="mc-alert-modal">
                            <Modal.Header closeButton>
                                <Modal.Title>Editar Gira de Estudios</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                              
                                      
                                    <Form.Group controlId="formAnio">
                                        <Form.Label>Año</Form.Label>
                                        <Form.Control type="number" name="gir_anio" value={giraData.gir_anio || ""} onChange={handleInputChange} />
                                    </Form.Group>

                                    <Form.Group controlId="formPrograma">
                                        <Form.Label>Programa</Form.Label>
                                        <Form.Select name="idprograma" value={giraData.idprograma || ""} onChange={handleInputChange}>
                                            <option>Seleccionar Programa</option>
                                            {selectPrograma?.map((programa) => (
                                                <option key={programa.id} value={programa.id}>{programa.nombre}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>

                                    <Form.Group controlId="formTramo">
                                        <Form.Label>Tramo</Form.Label>
                                        <Form.Select name="idtramo"  value={giraData.idtramo || ""} onChange={handleInputChange} >
                                            <option>Seleccionar Tramo</option>
                                            {selectTramo?.map((tramo) => (
                                                <option key={tramo.id} value={tramo.id}>{tramo.nombre}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                   
                                    <Form.Group controlId="formRegion">
                                        <Form.Label>Región</Form.Label>
                                        <Form.Select name="idregion" value={giraData.idregion || ""} onChange={handleRegionChange}>
                                            <option>Seleccionar Región</option>
                                            {selectRegion?.map((region) => (
                                                <option key={region.id} value={region.id}>{region.nombre}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>

                                    <Form.Group controlId="formComuna">
                                        <Form.Label>Comuna</Form.Label>
                                        <Form.Select name="idcomuna" value={giraData.idcomuna || ""} onChange={handleComunaChange}>
                                            <option>Seleccionar Comuna</option>
                                            {comunas?.map((comuna) => (
                                                <option key={comuna.com_id} value={comuna.com_id}>{comuna.com_nombre}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>

                                    <Form.Group controlId="formEstablecimiento">
                                        <Form.Label>Establecimiento</Form.Label>
                                        <Form.Control type="text" name="est_nombre" value={giraData.est_nombre || ""} onChange={handleInputChange} />
                                    </Form.Group>
                                   
                                    <Form.Group controlId="formCurso">
                                        <Form.Label>Curso</Form.Label>
                                        <Form.Control type="text" name="gir_curso" value={giraData.gir_curso} onChange={handleInputChange} />
                                    </Form.Group>

                                    <Form.Group controlId="formGiraEnDolares">
                                        <Form.Check 
                                            type="checkbox" 
                                            name="gir_pagodolares" 
                                            checked={giraData.gir_pagodolares?.data[0] || false} 
                                            onChange={handleInputChangeDolar}
                                            label="Gira en Dólares"
                                        />
                                    </Form.Group>

                                    <Form.Group controlId="formPorcentajeMulta">
                                        <Form.Label>Porcentaje Multa (%)</Form.Label>
                                        <Form.Control type="number" name="gir_porcmulta" value={giraData.gir_porcmulta || ""} onChange={handleInputChange} step="0.01" />
                                    </Form.Group>
                                   
                                    <Form.Group controlId="formLiberados">
                                        <Form.Label>Liberados</Form.Label>
                                        <Form.Control type="text" name="gir_liberados" value={giraData.gir_liberados} onChange={handleInputChange} />
                                    </Form.Group>
                                    <Form.Group controlId="formFechaViaje">
                                        <Form.Label>Fecha del Viaje</Form.Label>
                                        <Form.Control type="date" name="gir_fviajeact"     value={giraData.gir_fviajeact} onChange={handleInputChange} />
                                    </Form.Group>
                                    <Form.Group controlId="formFechaTerminoViaje">
                                        <Form.Label>Fecha Termino Viaje</Form.Label>
                                        <Form.Control type="date" name="gir_fterminoviajeact" value={giraData.gir_fterminoviajeact || ""} onChange={handleInputChange} />
                                    </Form.Group>
                                    <Form.Group controlId="formValorGira">
                                            <Form.Label>Precio Unitario Gira</Form.Label>
                                            <Form.Control type="number" name="gir_valorgira" value={giraData.gir_valorgira} onChange={handleInputChange} />
                                    </Form.Group>
                                    <Form.Group controlId="formValorServicioAdicional">
                                            <Form.Label>Valor Servicio Adicional</Form.Label>
                                            <Form.Control type="number" name="gir_valor_servicio_adicional" value={giraData.gir_valor_servicio_adicional || ""} onChange={handleInputChange} placeholder="Ingrese el valor del servicio adicional" />
                                    </Form.Group>
                                    <Form.Group controlId="formValorTotalGira">
                                            <Form.Label>Valor Total Gira</Form.Label>
                                            <Form.Control type="number" name="gir_valor_total_gira" value={giraData.gir_valor_total_gira || ""} onChange={handleInputChange} placeholder="Se calcula automáticamente" disabled />
                                    </Form.Group>
                                    <Form.Group controlId="formValorCuota">
                                        <Form.Label>Valor Cuota</Form.Label>
                                        <Form.Control type="number" name="gir_valorcuota" value={giraData.gir_valorcuota || ""} onChange={handleInputChange} />
                                    </Form.Group>
                                    <Form.Group controlId="formAbonoPagado">
                                        <Form.Label>Abono Pagado</Form.Label>
                                        <Form.Control type="number" name="gir_abonopagado" value={giraData.gir_abonopagado || ""} onChange={handleInputChange} />
                                    </Form.Group>
                                    <Form.Group controlId="formFechaInicioCuotas">
                                        <Form.Label>Fecha Inicio Cuotas</Form.Label>
                                        <Form.Control type="date" name="gir_fechainiciocuotas" value={giraData.gir_fechainiciocuotas || ""} onChange={handleInputChange} />
                                    </Form.Group>
                                    <Form.Group controlId="formFechaUltimaCuota">
                                        <Form.Label>Fecha Última Cuota</Form.Label>
                                        <Form.Control type="date" name="gir_fechaultimaacuota" value={giraData.gir_fechaultimaacuota || ""} onChange={handleInputChange} />
                                    </Form.Group>
                                    <Form.Group controlId="formFechaLimiteEdicion">
                                        <Form.Label>Fecha Límite de Edición de Datos del Pasajero</Form.Label>
                                        <Form.Control type="date" name="gir_fechalimiteedicion" value={giraData.gir_fechalimiteedicion || ""} onChange={handleInputChange} />
                                    </Form.Group>
                                    <Form.Group controlId="formDatosContacto">
                                        <Form.Label>Nombre del Responsable Curso</Form.Label>
                                        <Form.Control type="text" name="gir_contacto" value={giraData.gir_contacto} onChange={handleInputChange} />
                                    </Form.Group>
                                    <Form.Group controlId="formDatosContacto">
                                        <Form.Label>Celular del Responsable Curso</Form.Label>
                                        <Form.Control type="text" name="gir_celcontacto" value={giraData.gir_celcontacto} onChange={handleInputChange} />
                                    </Form.Group>
                                    <Form.Group controlId="formDatosContacto">
                                        <Form.Label>Email del Responsable Curso</Form.Label>
                                        <Form.Control type="text" name="gir_emailcontacto" value={giraData.gir_emailcontacto} onChange={handleInputChange} />
                                    </Form.Group>

                                    <hr className="my-4" />
                                    <h5>Información Adicional (Opcional)</h5>
                                    <hr className="my-3" />

                                    <Form.Group controlId="formGestor">
                                        <Form.Label>Gestor(a)</Form.Label>
                                        <Form.Control type="text" name="gir_gestor" value={giraData.gir_gestor || ""} onChange={handleInputChange} placeholder="Nombre del gestor" />
                                    </Form.Group>
                                    <Form.Group controlId="formGestorEmail">
                                        <Form.Label>Email Gestor(a)</Form.Label>
                                        <Form.Control type="email" name="gir_gestor_email" value={giraData.gir_gestor_email || ""} onChange={handleInputChange} placeholder="Email del gestor" />
                                    </Form.Group>

                                    <Form.Group controlId="formTraslado">
                                        <Form.Check 
                                            type="checkbox" 
                                            name="gir_traslado" 
                                            checked={giraData.gir_traslado || false}
                                            onChange={handleInputChange}
                                            label="Incluye Traslado Colegio-Apto-Colegio"
                                        />
                                    </Form.Group>
                                    {giraData.gir_traslado && (
                                        <>
                                            <Form.Group controlId="formPuntoEncuentro">
                                                <Form.Label>Punto de Encuentro</Form.Label>
                                                <Form.Control type="text" name="gir_punto_encuentro" value={giraData.gir_punto_encuentro || ""} onChange={handleInputChange} placeholder="Ej: Dirección Colegio, Aeropuerto Nacional, etc" />
                                            </Form.Group>
                                            <Form.Group controlId="formHorarioEncuentro">
                                                <Form.Label>Horario de Encuentro</Form.Label>
                                                <Form.Control type="time" name="gir_horario_encuentro" value={giraData.gir_horario_encuentro || ""} onChange={handleInputChange} />
                                            </Form.Group>
                                        </>
                                    )}

                                    <Form.Group controlId="formTipoTransporte">
                                        <Form.Label>Tipo de Transporte</Form.Label>
                                        <Form.Select name="gir_tipo_transporte" value={giraData.gir_tipo_transporte || ""} onChange={handleInputChange}>
                                            <option value="">Seleccionar Tipo</option>
                                            <option value="Aéreo">Aéreo</option>
                                            <option value="Terrestre">Terrestre</option>
                                        </Form.Select>
                                    </Form.Group>

                                    {giraData.gir_tipo_transporte === 'Aéreo' && (
                                        <>
                                            <Form.Group controlId="formAerolinea">
                                                <Form.Label>Aerolínea</Form.Label>
                                                <Form.Control type="text" name="gir_aerolinea" value={giraData.gir_aerolinea || ""} onChange={handleInputChange} placeholder="Nombre de la aerolínea" />
                                            </Form.Group>
                                            <Form.Group controlId="formNumVuelo">
                                                <Form.Label>Número de Vuelo</Form.Label>
                                                <Form.Control type="text" name="gir_num_vuelo" value={giraData.gir_num_vuelo || ""} onChange={handleInputChange} placeholder="Ej: LAN123" />
                                            </Form.Group>
                                            <Form.Group controlId="formCodigoReservaVuelo">
                                                <Form.Label>Código Reserva Vuelo</Form.Label>
                                                <Form.Control type="text" name="gir_codigo_reserva_vuelo" value={giraData.gir_codigo_reserva_vuelo || ""} onChange={handleInputChange} placeholder="Ej: ABC123XYZ" />
                                            </Form.Group>
                                            <Form.Group controlId="formHorarioVueloIda">
                                                <Form.Label>Horario Vuelo Ida</Form.Label>
                                                <Form.Control type="time" name="gir_horario_vuelo_ida" value={giraData.gir_horario_vuelo_ida || ""} onChange={handleInputChange} />
                                            </Form.Group>
                                            <Form.Group controlId="formHorarioVueloRegreso">
                                                <Form.Label>Horario Vuelo Regreso</Form.Label>
                                                <Form.Control type="time" name="gir_horario_vuelo_regreso" value={giraData.gir_horario_vuelo_regreso || ""} onChange={handleInputChange} />
                                            </Form.Group>
                                        </>
                                    )}

                                    {giraData.gir_tipo_transporte === 'Terrestre' && (
                                        <>
                                            <Form.Group controlId="formTipoBus">
                                                <Form.Label>Tipo de Bus</Form.Label>
                                                <Form.Control type="text" name="gir_tipo_bus" value={giraData.gir_tipo_bus || ""} onChange={handleInputChange} placeholder="Ej: Cama, Semi-cama, Turismo" />
                                            </Form.Group>
                                            <Form.Group controlId="formPatenteBus">
                                                <Form.Label>Patente Bus</Form.Label>
                                                <Form.Control type="text" name="gir_patente_bus" value={giraData.gir_patente_bus || ""} onChange={handleInputChange} placeholder="Ej: XXXX-XX" />
                                            </Form.Group>
                                            <Form.Group controlId="formNombreChofer1">
                                                <Form.Label>Nombre Chofer 1</Form.Label>
                                                <Form.Control type="text" name="gir_nombre_chofer1" value={giraData.gir_nombre_chofer1 || ""} onChange={handleInputChange} />
                                            </Form.Group>
                                            <Form.Group controlId="formTelChofer1">
                                                <Form.Label>Teléfono Chofer 1</Form.Label>
                                                <Form.Control type="text" name="gir_tel_chofer1" value={giraData.gir_tel_chofer1 || ""} onChange={handleInputChange} placeholder="Ej: +56 9 1234 5678" />
                                            </Form.Group>
                                            <Form.Group controlId="formNombreChofer2">
                                                <Form.Label>Nombre Chofer 2</Form.Label>
                                                <Form.Control type="text" name="gir_nombre_chofer2" value={giraData.gir_nombre_chofer2 || ""} onChange={handleInputChange} />
                                            </Form.Group>
                                            <Form.Group controlId="formTelChofer2">
                                                <Form.Label>Teléfono Chofer 2</Form.Label>
                                                <Form.Control type="text" name="gir_tel_chofer2" value={giraData.gir_tel_chofer2 || ""} onChange={handleInputChange} placeholder="Ej: +56 9 1234 5678" />
                                            </Form.Group>
                                            <Form.Group controlId="formHorarioSalida">
                                                <Form.Label>Horario de Salida</Form.Label>
                                                <Form.Control type="time" name="gir_horario_salida" value={giraData.gir_horario_salida || ""} onChange={handleInputChange} />
                                            </Form.Group>
                                            <Form.Group controlId="formHorarioRegreso">
                                                <Form.Label>Horario de Regreso</Form.Label>
                                                <Form.Control type="time" name="gir_horario_regreso" value={giraData.gir_horario_regreso || ""} onChange={handleInputChange} />
                                            </Form.Group>
                                        </>
                                    )}

                                    <Form.Group controlId="formCoordinador">
                                        <Form.Label>Coordinador(a)</Form.Label>
                                        <Form.Control type="text" name="gir_coordinador" value={giraData.gir_coordinador || ""} onChange={handleInputChange} placeholder="Nombre del coordinador" />
                                    </Form.Group>

                                    <Form.Group controlId="formHotel">
                                        <Form.Label>Nombre Hotel</Form.Label>
                                        <Form.Control type="text" name="gir_hotel" value={giraData.gir_hotel || ""} onChange={handleInputChange} placeholder="Nombre del hotel" />
                                    </Form.Group>

                                    <Form.Group controlId="formVoucherSeguro">
                                        <Form.Label>Nº Voucher Seguro Médico</Form.Label>
                                        <Form.Control type="text" name="gir_voucher_seguro" value={giraData.gir_voucher_seguro || ""} onChange={handleInputChange} placeholder="Número de voucher" />
                                    </Form.Group>

                                    <hr className="my-3" />

                                    <Form.Group controlId="formFechaReunionPresalida">
                                        <Form.Label>Fecha y Hora Reunión Pre-Salida</Form.Label>
                                        <Form.Control type="datetime-local" name="gir_fecha_reunion_presalida" value={giraData.gir_fecha_reunion_presalida || ""} onChange={handleInputChange} />
                                    </Form.Group>

                                    <Form.Group controlId="formModalidadReunion">
                                        <Form.Label>Modalidad Reunión</Form.Label>
                                        <Form.Select name="gir_modalidad_reunion" value={giraData.gir_modalidad_reunion || ""} onChange={handleInputChange}>
                                            <option value="">Seleccionar Modalidad</option>
                                            <option value="presencial">Presencial</option>
                                            <option value="virtual">Virtual</option>
                                        </Form.Select>
                                    </Form.Group>
                                    
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleCloseCreateGiraModal}>
                                    Cerrar
                                </Button>
                                <Button variant="primary" onClick={handleEditarGira}>
                                    Editar Gira
                                </Button>
                            </Modal.Footer>
                            </div>
                        </Modal>

            {/* MODAL CÓDIGO QR */}
            <Modal centered show={showQRModal} onHide={handleCloseQRModal}>
              <Modal.Header closeButton>
                <Modal.Title>Código QR - Listado de Pasajeros</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {qrData ? (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
                    {qrData.codigoQR && (
                      <div>
                        <img 
                          src={qrData.codigoQR} 
                          alt="Código QR" 
                          style={{ maxWidth: '300px', width: '100%' }}
                        />
                      </div>
                    )}
                    <div style={{ width: '100%' }}>
                      <p style={{ fontSize: '12px', color: '#666', marginBottom: '10px' }}>
                        <strong>Enlace de acceso:</strong>
                      </p>
                      <div style={{ 
                        display: 'flex', 
                        gap: '10px',
                        backgroundColor: '#f5f5f5',
                        padding: '10px',
                        borderRadius: '4px',
                        wordBreak: 'break-all'
                      }}>
                        <span style={{ fontSize: '12px', flex: 1 }}>{qrData.enlace}</span>
                       
                      </div>
                    </div>
                
                  </div>
                ) : (
                  <div style={{ textAlign: 'center', padding: '20px' }}>
                    <p>Cargando...</p>
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseQRModal}>
                  Cerrar
                </Button>
                <Button variant="primary" onClick={handleDescargarQR}>
                  <i className='material-icons' style={{ fontSize: '16px', marginRight: '5px' }}>download</i>
                  Descargar QR
                </Button>
              </Modal.Footer>
            </Modal>

            {/* MODAL COORDINADORES */}
            <Modal centered show={showCoordinadoresModal} onHide={handleCloseCoordinadoresModal} size="lg">
              <Modal.Header closeButton>
                <Modal.Title>Asignar Coordinadores a la Gira</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {loadingCoordinadores ? (
                  <div style={{ textAlign: 'center', padding: '20px' }}>
                    <p>Cargando coordinadores...</p>
                  </div>
                ) : coordinadoresDisponibles && coordinadoresDisponibles.length > 0 ? (
                  <div>
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th style={{ width: '50px' }}>
                              <input
                                type="checkbox"
                                checked={coordinadoresSeleccionados.length === coordinadoresDisponibles.length && coordinadoresDisponibles.length > 0}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setCoordinadoresSeleccionados(coordinadoresDisponibles.map(c => c.id));
                                  } else {
                                    setCoordinadoresSeleccionados([]);
                                  }
                                }}
                              />
                            </th>
                            <th>Nombre</th>
                            <th>Email</th>
                            <th>RUT</th>
                            <th>Estado</th>
                          </tr>
                        </thead>
                        <tbody>
                          {coordinadoresDisponibles.map((coordinador) => (
                            <tr key={coordinador.id}>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={coordinadoresSeleccionados.includes(coordinador.id)}
                                  onChange={() => handleToggleCoordinador(coordinador.id)}
                                />
                              </td>
                              <td>{coordinador.nombre} {coordinador.apellido}</td>
                              <td>{coordinador.email}</td>
                              <td>{coordinador.rut}-{coordinador.dv}</td>
                              <td>
                                {coordinador.activo ? (
                                  <span className="badge bg-success">Activo</span>
                                ) : (
                                  <span className="badge bg-danger">Inactivo</span>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div style={{ marginTop: '15px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                      <p><strong>Coordinadores seleccionados: {coordinadoresSeleccionados.length}</strong></p>
                    </div>
                  </div>
                ) : (
                  <div style={{ textAlign: 'center', padding: '20px' }}>
                    <p>No hay coordinadores disponibles</p>
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseCoordinadoresModal} disabled={loadingCoordinadores}>
                  Cancelar
                </Button>
                <Button variant="primary" onClick={handleGuardarCoordinadores} disabled={loadingCoordinadores}>
                  {loadingCoordinadores ? 'Guardando...' : 'Guardar Coordinadores'}
                </Button>
              </Modal.Footer>
            </Modal>
        </PageLayout>
    )
}